import i18n from 'i18next';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

const insuracePortalUserRole = isInsuracePortalUser();

export const driverStatusTableColumns = {
  columns: {
    [SERVICE_PROVIDERS.RADIUS]: [
      {
        id: 'eld',
        numeric: true,
        disablePadding: false,
        label: i18n.t('dashboard.tabs.driverStatus.eld'),
      },
    ],
    [SERVICE_PROVIDERS.NAUTO]: [
      {
        id: 'eld',
        numeric: true,
        disablePadding: false,
        label: i18n.t('dashboard.tabs.driverStatus.eld'),
      },
    ],
    [SERVICE_PROVIDERS.BRIGHT_ORDER]: [
      {
        id: 'eld',
        numeric: true,
        disablePadding: false,
        label: i18n.t('dashboard.tabs.driverStatus.eld'),
      },
    ],
    default: [],
  },
};

const commonPotential = [
  {
    id: 'driver',
    disablePadding: false,
    label: i18n.t('vehicles.fullName'),
  },
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: i18n.t('roadInspection.driverId'),
  },
  {
    id: 'phone',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.phone'),
  },
];

export const potentialViolationsTenantColumns = {
  columns: {
    [SERVICE_PROVIDERS.WEBFLEET]: [
      ...commonPotential,
      {
        id: 'date',
        disablePadding: false,
        label: i18n.t('common.date'),
        needSorting: true,
      },
      {
        id: 'violationType',
        disablePadding: false,
        label: i18n.t('dashboard.tabs.potentialViolations.violationType'),
      },
    ],
    default: [
      ...commonPotential,
      {
        id: 'violationType',
        disablePadding: false,
        label: i18n.t('dashboard.tabs.potentialViolations.violationType'),
      },
    ],
  },
};

export const radiusComplianceColumns = [
  ...(insuracePortalUserRole
    ? [
        {
          id: 'companyName',
          disablePadding: false,
          label: i18n.t('dashboard.tabs.radiusComplianceAlerts.company'),
          needSorting: true,
        },
        {
          id: 'type',
          disablePadding: false,
          label: i18n.t('dashboard.tabs.radiusComplianceAlerts.type'),
          needSorting: true,
        },
      ]
    : []),
  {
    id: 'description',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.description'),
    needSorting: true,
  },
  {
    id: 'date',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.date'),
    needSorting: true,
  },
  ...(insuracePortalUserRole
    ? [
        {
          id: 'lossControl',
          disablePadding: false,
          label: i18n.t('dashboard.tabs.radiusComplianceAlerts.lossControl'),
          needSorting: true,
        },
        {
          id: 'underwriter',
          disablePadding: false,
          label: i18n.t('dashboard.tabs.radiusComplianceAlerts.underwriter'),
          needSorting: true,
        },
      ]
    : []),
];

export const descColumns = [
  {
    id: 'description',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.description'),
    needSorting: true,
  },
  {
    id: 'date',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.radiusComplianceAlerts.date'),
    needSorting: true,
  },
];

export const getVehicleStatusColumns = (noSort) => [
  {
    id: 'vehicleName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.vehicleName'),
    needSorting: noSort ? false : true,
  },
  {
    id: 'vin',
    numeric: false,
    disablePadding: false,
    label: i18n.t('vehicles.vin'),
    needSorting: noSort ? false : true,
  },
  {
    id: 'esn',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.deviceSn'),
    needSorting: noSort ? false : true,
  },
  {
    id: 'latestLocation',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastKnownLocation'),
    needSorting: noSort ? false : true,
  },
  {
    id: 'seatBeltStatus',
    disablePadding: false,
    label: i18n.t('vehicles.seatBeltStatus'),
    needSorting: noSort ? false : true,
  },
];

export const alertColumns = [
  {
    id: 'description',
    disablePadding: false,
    label: i18n.t('common.description'),
    needSorting: true,
  },
  {
    id: 'date',
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: true,
  },
  {
    id: 'phone',
    disablePadding: false,
    label: i18n.t('common.phone'),
    needSorting: true,
  },
  { id: 'actions' },
];
